import { EmployeeList } from '../../../domain/employees/employeeList';
import StatusLabel from '../../shared/components/StatusLabel';
import { ViewDetails } from '../../shared/components/ViewDetails';
import Table from '../../shared/components/table/Table';

interface Props {
    data: EmployeeList[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export default function EmployeeTable({
    data: employees,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                { isSortable: true, name: 'FirstName', title: 'Nombre Completo' },
                { isSortable: true, name: 'Position.Name', title: 'Cargo' },
                { isSortable: true, name: 'Group.Name', title: 'Grupo' },
                {
                    isSortable: true,
                    name: 'DocumentNumber',
                    title: 'Numero de Identificación',
                },
                { isSortable: true, name: 'Email', title: 'Correo Electrónico' },
                { isSortable: true, name: 'IsActive', title: '' },
                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {employees.map((employee) => (
                <tr key={employee.id}>
                    <td>
                        {employee.firstName} {employee.middleName}{' '}
                        {employee.lastName} {employee.surname}
                    </td>
                    <td>{employee.positionName}</td>
                    <td>{employee.groupName}</td>
                    <td>{employee.documentNumber}</td>
                    <td>{employee.email}</td>
                    <td>
                        <StatusLabel value={employee.isActive} />
                    </td>
                    <td>
                        <ViewDetails
                            href={'/employees/update-employee/' + employee.id}
                        />
                    </td>
                </tr>
            ))}
        </Table>
    );
}
